import { render, staticRenderFns } from "./logisticstrajectory.vue?vue&type=template&id=c6ff931e&scoped=true"
import script from "./logisticstrajectory.vue?vue&type=script&lang=js"
export * from "./logisticstrajectory.vue?vue&type=script&lang=js"
import style0 from "./logisticstrajectory.vue?vue&type=style&index=0&id=c6ff931e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff931e",
  null
  
)

export default component.exports